module.exports = __webpack_public_path__ + "static/media/explore-Logo.b07ca5f1.svg";